module.exports = __webpack_public_path__ + "static/media/S.75f52318.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/S.jpg
// module id = 87
// module chunks = 0